var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-upvote-button",class:{
    'question-upvote-button--disabled': !_vm.buttonEnabled
  },attrs:{"disabled":!_vm.buttonEnabled},on:{"click":function($event){$event.preventDefault();return _vm.upvoteQuestion.apply(null, arguments)}}},[_c('div',{staticClass:"question-upvote-button__container"},[_c('ThumbsUpIcon',{staticClass:"question-upvote-button__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.totalUpvotesCount))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }